
import Vue from 'vue';

export default Vue.extend({
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        rideId: {
            type: Number,
        },
    },
    data() {
        return {
            formData: {
                title: '',
                message: '',
            },
            loading: false,
        };
    },
    methods: {
        closeForm() {
            this.$emit('input', false);
        },
        async sendNotification() {
            if (!this.formData.title || !this.formData.message) {
                this.$notifier.showError('Title and message is required');
                return;
            }
            const form = this.$refs.form as HTMLFormElement;
            if (form.validate()) {
                this.loading = true;
                try {
                    await this.$hipApi.sendRideNotification(this.rideId, this.formData.title, this.formData.message);
                    this.$notifier.showSuccess('Successfully sent notifications');
                } catch (e) {
                    console.error(e.message);
                    this.$notifier.showError('Failed to send notifications');
                }
                this.closeForm();
                this.loading = false;
            } else {
                this.$notifier.showError('There are errors on the form. Please fix them before continuing');
            }
        },
    },
});
